export default {
  text: 'Vérifier avec {{provider}}',
  text_generic: 'Vérifier avec votre fournisseur de paiement',
  error: "Nous n'avons pas pu ouvrir le formulaire {{provider}}. Veuillez réessayer.",
  error_generic: "Nous n'avons pas pu ouvrir le formulaire du fournisseur de paiement. Veuillez réessayer.",
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
